export enum LOG_TYPE {
  AUTH_DETAIL_RETRIEVAL_ERROR = 'auth_detail_retrieval_error',
  AUTH_DETAIL_RETRIEVAL_FOUND_NO_RESULTS = 'auth_detail_retrieval_found_no_results',
  AUTH_DETAIL_RETRIEVAL_SKIPPED = 'auth_detail_retrieval_skipped',
  AUTH_DETAIL_RETRIEVAL_SUCCESSFUL = 'auth_detail_retrieval_successful',
  AUTH_DETAIL_RETRIEVAL_DEDUPLICATION = 'auth_detail_retrieval_deduplication',
  AUTH_RECORD_CREATED_BY_HL7 = 'auth_record_created_by_hl7',
  AUTH_RECORD_CREATED_BY_SYSTEM = 'auth_record_created_by_system',
  AUTH_RECORD_CREATED_BY_USER = 'auth_record_created_by_user',
  AUTH_RECORD_LINKED_BY_SYSTEM = 'auth_record_linked_by_system',
  AUTH_RECORD_LINKED_BY_USER = 'auth_record_linked_by_user',
  AUTH_RECORD_UNLINKED_BY_USER = 'auth_record_unlinked_by_user',
  AUTH_RECORD_UPDATED_BY_SYSTEM = 'auth_record_updated_by_system',
  AUTH_RECORD_UPDATED_BY_USER = 'auth_record_updated_by_user',
  NONE = 'none',
  ESTIMATE_CREATED = 'estimate_created',
  ESTIMATE_DELETED = 'estimate_deleted',
  ESTIMATE_FINALIZED = 'estimate_finalized',
  ESTIMATE_MODIFIED = 'estimate_modified',
  ESTIMATE_MODIFY_STARTED = 'estimate_modify_started',
  ESTIMATE_MODIFY_DISCARDED = 'estimate_modify_discarded',
  ESTIMATE_INVOICE_PRINTED = 'estimate_invoice_printed',
  ESTIMATE_FAILED_INVOICE_SENT = 'estimate_failed_invoice_sent',
  ESTIMATE_INVOICE_SENT = 'estimate_invoice_sent',
  ESTIMATE_BALANCE_CREATED = 'estimate_balance_created',
  ESTIMATE_BALANCE_FINALIZED = 'estimate_balance_finalized',
  ESTIMATE_BALANCE_REVERTED = 'estimate_balance_reverted',
  ESTIMATE_BALANCE_PAYMENT_APPLIED = 'estimate_balance_payment_applied',
  ESTIMATE_BALANCE_REFUND_APPLIED = 'estimate_balance_refund_applied',
  ESTIMATE_BALANCE_RECALCULATED = 'estimate_balance_recalculated',
  ESTIMATE_BALANCE_MARKED_NA = 'estimate_balance_marked_na',
  ESTIMATE_BALANCE_MARKED_NOT_READY = 'estimate_balance_marked_not_ready',
  ESTIMATE_BALANCE_MARKED_NOT_STARTED = 'estimate_balance_marked_not_started',
  ESTIMATE_BALANCE_PAYMENT_PLAN_CREATED = 'estimate_balance_payment_plan_created',
  ESTIMATE_BALANCE_PAYMENT_PLAN_CANCELED = 'estimate_balance_payment_plan_canceled',
  INITIATE_AUTH_DETAIL_RETRIEVAL = 'initiate_auth_detail_retrieval',
  INITIATE_PATIENT_AUTH_DISCOVERY = 'initiate_patient_auth_discovery',
  PATIENT_AUTH_DISCOVERY_FOUND_NO_RESULTS = 'patient_auth_discovery_found_no_results',
  PATIENT_AUTH_DISCOVERY_PORTAL_ERROR = 'patient_auth_discovery_portal_error',
  PATIENT_AUTH_DISCOVERY_SKIPPED = 'patient_auth_discovery_skipped',
  PATIENT_AUTH_DISCOVERY_SUCCESSFUL = 'patient_auth_discovery_successful',
  PROCESSED_PATIENT_ACCOUNT_AUTHORIZATION_CLEARANCE = 'processed_patient_account_authorization_clearance',
  PROCESSED_PATIENT_ACCOUNT_CLEARANCE = 'processed_patient_account_clearance',
}

const LOG_TYPE_NAMES: Record<LOG_TYPE, string> = {
  [LOG_TYPE.AUTH_DETAIL_RETRIEVAL_ERROR]: 'Auth Detail Retrieval Error',
  [LOG_TYPE.AUTH_DETAIL_RETRIEVAL_FOUND_NO_RESULTS]: 'Auth Detail Retrieval Found No Results',
  [LOG_TYPE.AUTH_DETAIL_RETRIEVAL_SKIPPED]: 'Auth Detail Retrieval Skipped',
  [LOG_TYPE.AUTH_DETAIL_RETRIEVAL_SUCCESSFUL]: 'Auth Detail Retrieval Successful',
  [LOG_TYPE.AUTH_DETAIL_RETRIEVAL_DEDUPLICATION]: 'Auth Detail Retrieval Deduplication',
  [LOG_TYPE.AUTH_RECORD_CREATED_BY_HL7]: 'Auth Record Created By HL7',
  [LOG_TYPE.AUTH_RECORD_CREATED_BY_SYSTEM]: 'Auth Record Created By System',
  [LOG_TYPE.AUTH_RECORD_CREATED_BY_USER]: 'Auth Record Created by User',
  [LOG_TYPE.AUTH_RECORD_LINKED_BY_SYSTEM]: 'Auth Record Linked By System',
  [LOG_TYPE.AUTH_RECORD_LINKED_BY_USER]: 'Auth Record Linked By User',
  [LOG_TYPE.AUTH_RECORD_UNLINKED_BY_USER]: 'Auth Record Unlinked By User',
  [LOG_TYPE.AUTH_RECORD_UPDATED_BY_SYSTEM]: 'Auth Record Updated By System',
  [LOG_TYPE.AUTH_RECORD_UPDATED_BY_USER]: 'Auth Record Updated by User',
  [LOG_TYPE.ESTIMATE_CREATED]: 'Estimate Created',
  [LOG_TYPE.ESTIMATE_DELETED]: 'Estimate Deleted',
  [LOG_TYPE.ESTIMATE_FINALIZED]: 'Estimate Finalized',
  [LOG_TYPE.ESTIMATE_MODIFIED]: 'Estimate Modified',
  [LOG_TYPE.ESTIMATE_MODIFY_STARTED]: 'Estimate Modify Started',
  [LOG_TYPE.ESTIMATE_MODIFY_DISCARDED]: 'Estimate Modify Discarded',
  [LOG_TYPE.ESTIMATE_INVOICE_PRINTED]: 'Estimate Invoice Printed',
  [LOG_TYPE.ESTIMATE_FAILED_INVOICE_SENT]: 'Estimate Failed Invoice Sent',
  [LOG_TYPE.ESTIMATE_INVOICE_SENT]: 'Estimate Invoice Sent',
  [LOG_TYPE.ESTIMATE_BALANCE_CREATED]: 'Estimate Balance Created',
  [LOG_TYPE.ESTIMATE_BALANCE_FINALIZED]: 'Estimate Balance Finalized',
  [LOG_TYPE.ESTIMATE_BALANCE_REVERTED]: 'Estimate Balance Reverted',
  [LOG_TYPE.ESTIMATE_BALANCE_PAYMENT_APPLIED]: 'Estimate Balance Payment Applied',
  [LOG_TYPE.ESTIMATE_BALANCE_REFUND_APPLIED]: 'Estimate Balance Refund Applied',
  [LOG_TYPE.ESTIMATE_BALANCE_RECALCULATED]: 'Estimate Balance Recalculated',
  [LOG_TYPE.ESTIMATE_BALANCE_MARKED_NA]: 'Estimate Balance Marked N/A',
  [LOG_TYPE.ESTIMATE_BALANCE_MARKED_NOT_READY]: 'Estimate Balance Marked Not Ready',
  [LOG_TYPE.ESTIMATE_BALANCE_MARKED_NOT_STARTED]: 'Estimate Balance Marked Not Started',
  [LOG_TYPE.ESTIMATE_BALANCE_PAYMENT_PLAN_CREATED]: 'Estimate Balance Payment Plan Created',
  [LOG_TYPE.ESTIMATE_BALANCE_PAYMENT_PLAN_CANCELED]: 'Estimate Balance Payment Plan Canceled',
  [LOG_TYPE.NONE]: 'None',
  [LOG_TYPE.INITIATE_AUTH_DETAIL_RETRIEVAL]: 'Initiate Auth Detail Retrieval',
  [LOG_TYPE.INITIATE_PATIENT_AUTH_DISCOVERY]: 'Initiate Patient Auth Discovery',
  [LOG_TYPE.PATIENT_AUTH_DISCOVERY_FOUND_NO_RESULTS]: 'Patient Auth Discovery Found No Results',
  [LOG_TYPE.PATIENT_AUTH_DISCOVERY_PORTAL_ERROR]: 'Patient Auth Discovery Portal Error',
  [LOG_TYPE.PATIENT_AUTH_DISCOVERY_SKIPPED]: 'Patient Auth Discovery Skipped',
  [LOG_TYPE.PATIENT_AUTH_DISCOVERY_SUCCESSFUL]: 'Patient Auth Discovery Successful',
  [LOG_TYPE.PROCESSED_PATIENT_ACCOUNT_AUTHORIZATION_CLEARANCE]: 'Processed Patient Account Authorization Clearance',
  [LOG_TYPE.PROCESSED_PATIENT_ACCOUNT_CLEARANCE]: 'Processed Patient Account Clearance',
}

export function getLogTypeName(type: LOG_TYPE): string {
  return LOG_TYPE_NAMES[type]
}
